import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import Projects from './Applynow/projectsdata';
import Internships from './Applynow/internships';
import Jobs from "./Applynow/jobs";
import AppliedJobsList from "./Applynow/appliedlist";

const Applyforworks = () => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <Box sx={{ width : '100%', minHeight : '100vh', backgroundColor: 'rgb(235, 239, 255)', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
           <Box sx={{ position: 'sticky', top : 0, zIndex: 10, width : '100%' }}>
            <Tabs
                value={activeTab}
                onChange={(event, newValue) => setActiveTab(newValue)}
                indicatorColor="secondary"
                textColor="inherit"
                variant="fullWidth"
                sx={{
                background: 'linear-gradient(to right, #043885, #1B6EF4)',
                color: 'white',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                '& .MuiTab-root': {
                    color: 'white',
                    fontWeight: 600,
                    fontSize: '15px',
                },
                '& .Mui-selected': {
                    color: '#FFD700',
                },
                '& .MuiTabs-indicator': {
                    backgroundColor: '#FFD700',
                    height : '4px',
                    borderRadius: '2px',
                },
                }}
            >
                <Tab label="Projects" />
                <Tab label="Internships" />
                <Tab label="Jobs" />
                <Tab label="Applied List" />
            </Tabs>
            </Box>
            <Box 
                sx={{ 
                    mt: 1, 
                    width : '100%', 
                    display: 'flex', 
                    justifyContent: "center", 
                    alignItems: "center",
                    p: 1
                }}
            >
                {activeTab === 0 && <Projects setActiveLink={setActiveTab} />}
                {activeTab === 1 && <Internships setActiveLink={setActiveTab} />}
                {activeTab === 2 && <Jobs setActiveLink={setActiveTab} />}
                {activeTab === 3 && <AppliedJobsList setActiveLink={setActiveTab} />}
            </Box>
        </Box>
    );
};

export default Applyforworks;
